export const enum USER {
  AGENT_SIMPLE = "agent",
  BANK_AGENT_SIMPLE = "bank", //no
  BANK_AGENT_ADMIN = "bank", //no
  CLIENT_SIMPLE = "client",
  SUPPORT_ADMIN = "admin",
  SUPPORT_CREDIT = "support.credit",
  MANAGER = "manager",
  BANNED = "banned", //no
}
